import type { DocPageContent } from '../docs-content'

const page = {
  order: 1,
  slug: 'getting-started',
  title: 'Primeros pasos',
  description:
    'Qué es CachoCut, cómo realizar tu primera edición desde el inicio hasta la exportación.',
  category: 'Inicio',
  related: ['concepts', 'workspaces', 'export'],
  sections: [
    {
      title: '¿Qué es CachoCut?',
      blocks: [
        {
          kind: 'paragraph',
          text: 'CachoCut es un editor de video. No necesitas crear una cuenta, subir archivos. La edición, los efectos, la corrección de color, las herramientas de IA y la exportación se ejecutan íntegramente en tu propio equipo utilizando la GPU y la CPU.',
        },
        {
          kind: 'note',
          tone: 'tip',
          text: 'Tus archivos multimedia permanecen siempre en tu dispositivo. CachoCut crea enlaces a los archivos originales y guarda los proyectos, la caché y las exportaciones en una **carpeta de espacio de trabajo** que tú eliges. Nada se envía a la nube.',
        },
      ],
    },
    {
      title: 'Requisitos',
      blocks: [
        
        
        {
          kind: 'note',
          tone: 'info',
          text: 'CachoCut utiliza la File System Access API (carpetas de espacio de trabajo), WebCodecs (decodificación y exportación), WebGPU (efectos, color e IA) y OPFS (cachés). Mantén activada la aceleración por hardware y los controladores de la GPU actualizados.',
        },
        
      ],
    },
    {
      title: 'Tu primera edición',
      blocks: [
        {
          kind: 'steps',
          items: [
            'Abre CachoCut y, cuando se te solicite, elige una **carpeta de espacio de trabajo** sobre la que tengas permisos de lectura y escritura.',
            'En la página de Proyectos, selecciona **Nuevo proyecto** y configura la resolución y la velocidad de fotogramas que utilizará la edición.',
            'Abre la pestaña **Multimedia** y utiliza **Importar** para agregar archivos, o simplemente arrástralos directamente a la biblioteca.',
            'Arrastra un clip desde el panel Multimedia hasta una pista de la línea de tiempo.',
            'Presiona `Espacio` para reproducir el proyecto y utiliza las teclas `Izquierda` y `Derecha` para avanzar o retroceder un fotograma a la vez.',
            'Guarda tu trabajo con `Ctrl+S` mientras editas y, cuando hayas terminado, selecciona **Exportar** para generar el video final.',
          ],
        },
      ],
    },
    {
      title: 'Comprueba que todo funciona correctamente',
      blocks: [
        {
          kind: 'list',
          items: [
            'Se abre el selector de espacio de trabajo y permite elegir una carpeta normal (no una ubicación protegida del sistema).',
            'Los archivos importados aparecen como tarjetas con miniaturas en el panel Multimedia.',
            'La reproducción comienza desde la línea de tiempo al presionar `Espacio`.',
            'La ventana de exportación se abre correctamente y la comprobación previa no informa de ningún problema que impida continuar.',
          ],
        },
        {
          kind: 'note',
          tone: 'tip',
          text: 'Si alguno de estos pasos falla, consulta la página **Solución de problemas** para encontrar la solución correspondiente.',
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page